import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowRight, FaBookmark, FaMapMarkerAlt } from 'react-icons/fa';
import '../css/placeToVisit.css'; // Import the CSS file for styling
import { placesToVisit } from './placeData';
import { notifyInfo, notifySuccess } from '../utils/notify';
import { isTripItemSaved, saveTripItem } from '../utils/tripPlanner';

const PlacesToVisitInKimberley = () => {
  const navigate = useNavigate();

  const openPlace = (place) => {
    navigate(`/places/${place.slug}`, { state: { place } });
  };

  const savePlace = (event, place) => {
    event.stopPropagation();

    const plannerItem = {
      title: place.name,
      description: place.description,
      image: place.image,
      category: place.category,
      location: place.location,
      detailPath: `/places/${place.slug}`,
      detailState: { place },
    };
    const result = saveTripItem(plannerItem);

    if (result.saved) {
      notifySuccess(`${place.name} saved to your trip planner.`);
      return;
    }

    notifyInfo(`${place.name} is already in your trip planner.`);
  };

  return (
    <div className="places-container">
      <h1 className="places-title">Discover the Best of Kimberley</h1>
      <p className="places-subtitle">Explore these stunning destinations that make Kimberley a must-visit city.</p>
      <div className="places-grid">
        {placesToVisit.map((place, index) => (
          <div key={index} className="place-card" onClick={() => openPlace(place)}>
            <div className="place-image-container">
              <img src={place.image} alt={place.name} className="place-image" />
              <button
                type="button"
                className={`place-save-button ${
                  isTripItemSaved({ title: place.name, category: place.category })
                    ? "saved"
                    : ""
                }`}
                onClick={(event) => savePlace(event, place)}
                aria-label={`Save ${place.name} to trip planner`}
              >
                <FaBookmark />
              </button>
              <div className="place-overlay">
                <span>
                  <FaMapMarkerAlt />
                  Kimberley
                </span>
                <h2 className="place-name">{place.name}</h2>
              </div>
            </div>
            <p className="place-description">{place.description}</p>
            <button type="button" className="visit-button-2">
              Explore More
              <FaArrowRight />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlacesToVisitInKimberley;
